import { render, staticRenderFns } from "./ManualAddCamera.vue?vue&type=template&id=cfdaada2&scoped=true&"
import script from "./ManualAddCamera.vue?vue&type=script&lang=js&"
export * from "./ManualAddCamera.vue?vue&type=script&lang=js&"
import style0 from "./ManualAddCamera.vue?vue&type=style&index=0&id=cfdaada2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdaada2",
  null
  
)

export default component.exports